/**
 * The stacking level of UI floated over a Leaflet map: ONE number for every map screen.
 *
 * Leaflet stacks its own panes up to 1000 (tiles 200, markers 600, popups 700, controls 1000),
 * so a card that floats over the map must sit above that or the map paints over it. Hit-testing
 * still falls through Leaflet's `pointer-events: none` panes to the card, so a DOM probe reports
 * it on top while the screenshot shows no card (FleetRoutes, found by looking at the pixels).
 *
 * ⚠️ Pair it with `isolation: isolate` on the box the card floats in: an un-isolated 1100
 * also draws over the app's own overlays (the preview Sheet is z 50).
 *
 * ⚠️ Two literal class strings, not one string with a variant glued on at runtime: Tailwind
 * generates only the classes it finds written out in the source.
 */
export const MAP_OVERLAY_Z = 'z-[1100]';
/** `MAP_OVERLAY_Z` from the `lg` breakpoint up (Fleet's panel floats only on wide screens). */
export const MAP_OVERLAY_Z_LG = 'lg:z-[1100]';
